import Vue from 'vue'
import Vuex from 'vuex'
import app from "@/store/modules/app";
import user from "@/store/modules/user";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activityNo:'COINCOIN7M'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    user
  }
})
